<template>
    <v-app id="inspire">
        <v-navigation-drawer
                v-model="drawer"
                app
                width="180"
                dark


        >
            <v-list-item>
                <v-list-item-content>
                    <v-list-item-title class="text-h6 " align="center">
                        TRAVEL
                    </v-list-item-title>

                </v-list-item-content>

            </v-list-item>

            <v-divider></v-divider>
            <v-list shaped nav>
                
                <v-list-item
                        v-for="item in items1"
                        :key="$t(item.title)"
                        :to="item.to"
                        dense
                        active-class="warning"

                >
                    <v-list-item-icon>
                        <v-icon>{{ item.icon }}</v-icon>
                    </v-list-item-icon>

                    <v-list-item-content>
                        <v-list-item-title>{{ $t(item.title) }}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </v-list>
            <v-list
                    shaped
                    dark
                    nav

            >


                <v-list-item
                        v-for="item in items"
                        :key="$t(item.title)"
                        :to="item.to"
                        dense
                        active-class="warning"

                >
                    <v-list-item-icon>
                        <v-icon>{{ item.icon }}</v-icon>
                    </v-list-item-icon>

                    <v-list-item-content>
                        <v-list-item-title>{{ $t(item.title) }}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

            </v-list>

        </v-navigation-drawer>

        <v-app-bar app flat color="green darken-4" dark height="50">
            <v-app-bar-nav-icon @click="drawer = !drawer"></v-app-bar-nav-icon>

            <v-toolbar-title>{{$t('MAIN.COMPANY_NAME')}}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn text value="en" @click="$store.dispatch('setLang','en')">EN</v-btn>
            <v-btn text value="la" @click="$store.dispatch('setLang','la')">ລາວ</v-btn>
            <v-divider vertical class="mx-2"></v-divider>
            <v-btn icon to="/user">
                <v-icon>mdi-account</v-icon>
            </v-btn>
            <v-btn icon  @click="logout">
                <v-icon>mdi-power</v-icon>
            </v-btn>
        </v-app-bar>
        <loader-component></loader-component>
        <action-status></action-status>

        <v-main class="ma-2">
            <router-view></router-view>
        </v-main>
    </v-app>
</template>

<script>
    import ActionStatus from "@/components/actionStatus";
    import LoaderComponent from "@/components/Loader";
    export default {
        name: "MainLayout",
        components: {LoaderComponent, ActionStatus},
        data: () => ({
            drawer: null,
            items: [
                {title: 'GROUP.POLICY', icon: 'mdi-airplane-clock', to: '/travel'},
                {title: 'GROUP.SEARCH', icon: 'mdi-magnify', to: '/travel-search'},
                {title: 'GROUP.REPORT', icon: 'mdi-chart-bar', to: '/travel-report'},
                // {title: 'GROUP.ENTRY', icon: 'mdi-airplane-check', to: '/entry-report'},


            ],
            items1: [
                {title: 'MAIN.HOME', icon: 'mdi-view-dashboard', to: '/home'},


            ]
        }),
        methods: {
            async logout() {
                await this.$store.dispatch('logout')

            },
        }
    }
</script>

<style scoped>
    .v-application--is-ltr .v-list-item__action:first-child, .v-application--is-ltr .v-list-item__icon:first-child {
        margin-right: 15px;
    }
</style>